webpackJsonp([1],{

/***/ 102:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(96)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(53),
  /* template */
  __webpack_require__(107),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 103:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(94)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(54),
  /* template */
  __webpack_require__(105),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 104:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.country === 'AU' ? 'https://forms.gle/32AmjZTQXWQHs5su7' : 'https://dancestudio-pro.com/online/campbelldancers',
      "target": "_blank"
    }
  }, [_vm._v("Enroll")])
},staticRenderFns: []}

/***/ }),

/***/ 105:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "privacy"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "bg-tartan"
  }, [_vm._m(1), _vm._v(" "), _c('div', [_c('p', [_vm._v("If you have created an account and would like your data permanently deleted from all of our systems—for whatever reason—please "), _c('router-link', {
    attrs: {
      "to": "/#contact"
    }
  }, [_c('strong', [_vm._v("contact us")])]), _vm._v(" to make this request.")], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('header', [_c('h2', [_vm._v("Privacy Policy")])]), _vm._v(" "), _c('div', [_c('p', [_c('em', [_vm._v("CSHD")]), _vm._v(" uses enterprise-grade services and industry-standard security practices for storing and communicating all data. "), _c('strong', [_c('em', [_vm._v("CSHD")]), _vm._v(" does not share, sell, or advertise with user data in any capacity.")])]), _vm._v(" "), _c('p', [_vm._v("Any potentially user-identifying data gathered is used "), _c('strong', [_vm._v("exclusively for the purpose of coordinating enrollments, communicating with staff")]), _vm._v(", improving the app, fixing bugs in the code, providing support, etc.")]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("If you navigate/use the site/app")]), _vm._v(", common web traffic stats are collected:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("basic analytics information, like: pageviews, IP addresses, dates and times")]), _vm._v(" "), _c('li', [_vm._v("device-type information, e.g.: operating system, web browser name and version")]), _vm._v(" "), _c('li', [_vm._v("information required by third-party services in order to function; for instance: cookies for determining login state")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("If you enroll for a class")]), _vm._v(", only the data you explicitly input will be stored, such as:")]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("your email address")]), _vm._v(" "), _c('li', [_vm._v("your name")]), _vm._v(" "), _c('li', [_vm._v("information about you and/or your dancer(s), such as birthdates and allergies/medical conditions")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_vm._v("Data Deletion")])])
}]}

/***/ }),

/***/ 106:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', {
    staticClass: "align-center",
    class: {
      toggled: _vm.menuToggled
    },
    attrs: {
      "id": "header"
    },
    on: {
      "click": function($event) {
        _vm.menuToggled = false
      }
    }
  }, [_c('div', [_c('header', {
    on: {
      "click": function($event) {
        _vm.menuToggled = false
      }
    }
  }, [_c('h1', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icon.svg",
      "alt": "Campbell School of Highland Dance"
    }
  })])], 1)]), _vm._v(" "), _c('aside', {
    staticClass: "heading",
    attrs: {
      "title": "Campbell School of Highland Dance"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("CSHD")])], 1), _vm._v(" "), _c('nav', [_c('router-link', {
    attrs: {
      "to": "/#about"
    }
  }, [_vm._v("About")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/#schedule"
    }
  }, [_vm._v("Registration")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("Contact")]), _vm._v(" "), _c('EnrollButton'), _vm._v(" "), _c('label', {
    staticClass: "selectable"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.country),
      expression: "country"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.country = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, _vm.handleCountryChange]
    }
  }, _vm._l((_vm.countries), function(info, code) {
    return _c('option', {
      key: code,
      domProps: {
        "value": code
      }
    }, [_vm._v(_vm._s(info.flag))])
  }), 0)])], 1), _vm._v(" "), _c('footer', [_c('button', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.menuToggled = !_vm.menuToggled
      }
    }
  }, [_c('i', [_vm._v("Menu")])])])])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('footer', {
    staticClass: "align-center",
    attrs: {
      "id": "footer"
    }
  }, [_c('header', [_c('div', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Campbell School of Highland Dance")]), _vm._v("  •  2016–" + _vm._s(_vm.year))], 1)])])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 107:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    ref: "banner",
    attrs: {
      "id": "banner"
    }
  }, [_c('img', {
    staticStyle: {
      "max-height": "60vh"
    },
    style: ({
      transformOrigin: 'center bottom',
      transform: ("scale(" + (Math.max(0, Math.min(1 - _vm.bannerOffset, 1))) + ")")
    }),
    attrs: {
      "src": "/static/images/logo.svg"
    }
  })]), _vm._v(" "), _c('VueperSlides', {
    attrs: {
      "autoplay": ""
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('VueperSlide', {
      key: image,
      attrs: {
        "image": image
      }
    })
  }), 1), _vm._v(" "), _c('section', {
    staticClass: "bg-tartan align-center"
  }, [_c('div', {
    staticClass: "align-justify"
  }, [_c('p', [_vm._v("We are a modern "), _c('strong', [_vm._v("Scottish Highland dancing studio")]), _vm._v(" for competitive and recreational dancers located in "), (_vm.country === 'AU') ? _c('span', [_c('strong', [_vm._v("Alfred Cove")]), _vm._v(", Western Australia")]) : _c('span', [_c('strong', [_vm._v("Calgary")]), _vm._v(", Alberta, Canada")]), _vm._v(".")]), _vm._v(" "), (_vm.country === 'AU') ? _c('p', [_vm._v("CSHD values "), _vm._m(0), _vm._v(", which foster an environment where dancers and their families thrive. Our training program develops strong, confident, and joyful performers, focusing on technical excellence and a love of dance.")]) : _c('p', [_c('strong', [_vm._v("Excellence")]), _vm._v(", "), _c('strong', [_vm._v("athleticism")]), _vm._v(", and "), _c('strong', [_vm._v("community")]), _vm._v(" are the core values that guide our instruction, creating a supportive and enthusiastic space where dancers and their families thrive. Our training develops strong, confident, and joyful performers, focusing on technical excellence and a life-long love of dance.")])]), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('p', [_vm._v("Are you located in "), _c('strong', [_vm._v(_vm._s(_vm.otherInfo.flag) + " " + _vm._s(_vm.otherInfo.name))]), _vm._v(", not " + _vm._s(_vm.info.flag) + " " + _vm._s(_vm.info.name) + "?")]), _vm._v(" "), _c('a', {
    staticClass: "btn",
    attrs: {
      "href": _vm.otherInfo.url
    }
  }, [_vm._v("Visit " + _vm._s(_vm.otherInfo.nationality) + " Site")])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "about"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "align-justify"
  }, [_c('p', [_vm._v("Our youngest dancers "), _c('strong', [_vm._v("learn about movement")]), _vm._v(" through play-based activities and technical instruction. The basics of "), _c('strong', [_vm._v("highland technique")]), _vm._v(" are introduced in a fun, easy, low pressure environment. Our little leapers "), (_vm.country === 'AU') ? _c('span', [_vm._v("can also")]) : _vm._e(), _vm._v(" begin to "), _c('strong', [_vm._v("develop stage presence")]), _vm._v(" through opportunities to perform for small audiences.")]), _vm._v(" "), _c('p', [_vm._v("Dancers develop a high level of technique through a combination of traditional exercises, cross-training, and strength training. Contemporary group "), _c('strong', [_vm._v("choreography and performances")]), _vm._v(" quickly become a happy staple in their dance training. Competition is encouraged for returning dancers, to build confidence and comfort with performing. "), _c('strong', [_vm._v("Friendships and bonds")]), _vm._v(" are nurtured through our core values of "), (_vm.country === 'AU') ? _c('span', [_vm._v("sustainability, community, and athleticism")]) : _c('span', [_vm._v("excellence, athleticism, and community")]), _vm._v(", helping to build well-rounded, enthusiastic dancers who feel "), _c('strong', [_vm._v("supported")]), _vm._v(", "), _c('strong', [_vm._v("loved")]), _vm._v(", and "), _c('strong', [_vm._v("challenged")]), _vm._v(".")])]), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('EnrollButton')], 1)]), _vm._v(" "), _c('section', {
    staticClass: "bg-tartan",
    attrs: {
      "id": "schedule"
    }
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "align-center"
  }, [_vm._m(3), _vm._v(" "), (_vm.country === 'AU') ? [_c('p', [_vm._v("Mondays - 3:30-4:10pm")]), _vm._v(" "), _c('p', [_vm._v("Mondays - 4:15-4:55pm")])] : [_c('p', [_vm._v("Dancers 4-6 Years - Mondays - 3:45-4:30pm")]), _vm._v(" "), _c('p', [_vm._v("Dancers 7 Years & Older - Wednesdays - 4:30-5:15pm")])], _vm._v(" "), _c('br'), _vm._v(" "), (_vm.country === 'AU') ? _c('p', [_vm._v("\n        For expressions of interest for other days, please "), _c('router-link', {
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("contact us")]), _vm._v(".\n      ")], 1) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("\n        Classes are loosely grouped by both age and ability; if you are unsure which class is appropriate, please "), _c('router-link', {
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("contact us")]), _vm._v("!\n      ")], 1), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('EnrollButton')], 1)], 2), _vm._v(" "), (_vm.country !== 'AU') ? _c('div', {
    staticClass: "align-center",
    attrs: {
      "id": "prices"
    }
  }, [_vm._m(4), _vm._v(" "), (_vm.country === 'AU') ? _c('table', {
    staticClass: "table align-center"
  }, [_vm._m(5), _vm._v(" "), _vm._m(6)]) : _c('table', {
    staticClass: "table"
  }, [_vm._m(7)]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("Contact Us")])], 1)]) : _vm._e()]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "instructors"
    }
  }, [_c('header', [_c('h2', [_c('a', {
    attrs: {
      "href": "#instructors"
    }
  }, [_vm._v("Instructor" + _vm._s(_vm.country === 'AU' ? '' : 's'))])])]), _vm._v(" "), (_vm.country === 'AU') ? _c('div', [_vm._m(9)]) : _c('div', [_vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(11)]), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('router-link', {
    staticClass: "btn",
    attrs: {
      "to": "/#contact"
    }
  }, [_vm._v("Contact Us")])], 1)]), _vm._v(" "), _c('section', {
    staticClass: "bg-tartan",
    attrs: {
      "id": "contact"
    }
  }, [_vm._m(12), _vm._v(" "), _c('div', {
    staticClass: "flex-cols"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Email")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": ("mailto:" + (_vm.info.email))
    }
  }, [_vm._v(_vm._s(_vm.info.email))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Phone")]), _vm._v(" "), _c('td', [_c('a', {
    attrs: {
      "href": ("tel:+" + (_vm.info.phone.replace(/[^\d]/g, '')))
    }
  }, [_vm._v(_vm._s(_vm.info.phone))])])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Locations")]), _vm._v(" "), _c('td', [_c('ul', _vm._l((_vm.locations), function(location) {
    return _c('li', {
      key: location.name
    }, [_c('em', [_vm._v(_vm._s(location.name))]), _c('br'), _vm._v(" "), _c('a', {
      attrs: {
        "href": ("https://www.google.ca/maps/place/" + (encodeURIComponent(location.address))),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(location.address))])])
  }), 0)])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Links")]), _vm._v(" "), _c('td', [_c('ul', _vm._l((_vm.info.links), function(link) {
    return _c('li', {
      key: link.url
    }, [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), 0)])])])]), _vm._v(" "), _c('form', {
    attrs: {
      "method": "post",
      "action": ("//formspree.io/" + (_vm.info.email)),
      "target": "_blank"
    }
  }, [_c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "text",
      "name": "_gotcha"
    }
  }), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "name": "_subject",
      "value": "Contact Form on CSHD"
    }
  }), _vm._v(" "), _vm._m(13)])])]), _vm._v(" "), _c('section', {
    attrs: {
      "id": "photos"
    }
  }, [_vm._m(14), _vm._v(" "), _c('footer', {
    staticClass: "call-to-action align-center"
  }, [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": ("https://www.instagram.com/" + (_vm.info.instagram) + "/"),
      "target": "_blank"
    }
  }, [_vm._v("Visit Instagram")])])]), _vm._v(" "), _vm._m(15)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('strong', [_vm._v("sustainability")]), _vm._v(", "), _c('strong', [_vm._v("community")]), _vm._v(", and "), _c('strong', [_vm._v("athleticism")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_c('a', {
    attrs: {
      "href": "#about"
    }
  }, [_vm._v("About")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "align-center"
  }, [_c('h2', [_c('a', {
    attrs: {
      "href": "#schedule"
    }
  }, [_vm._v("Registration")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Now accepting new dancers in the following classes:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h3', [_c('a', {
    attrs: {
      "href": "#prices"
    }
  }, [_vm._v("Prices")])]), _vm._v(" "), _c('h4', [_vm._v("Per dancer")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Class time per week")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Cost per term")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "33%"
    }
  }, [_vm._v("Cost per casual class")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v("30 mins")]), _vm._v(" "), _c('td', [_vm._v("$60")]), _vm._v(" "), _c('td', [_vm._v("$7.50")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("45 mins")]), _vm._v(" "), _c('td', [_vm._v("$90")]), _vm._v(" "), _c('td', [_vm._v("$12.50")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("60 mins")]), _vm._v(" "), _c('td', [_vm._v("$120")]), _vm._v(" "), _c('td', [_vm._v("$15")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Private 60 mins")]), _vm._v(" "), _c('td', [_vm._v("$250")]), _vm._v(" "), _c('td', [_vm._v("$30")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Sibling discount")]), _vm._v(" "), _c('td', [_vm._v("25%")]), _vm._v(" "), _c('td', [_vm._v("25%")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tbody', [_c('tr', [_c('td', [_vm._v("Classes start at")]), _vm._v(" "), _c('td', [_vm._v("$100/month")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('aside', [_c('p', [_vm._v("A proud partner of "), _c('strong', [_vm._v("KidSport Society of Calgary")]), _vm._v(", which provides grants to cover registration costs. "), _c('a', {
    attrs: {
      "href": "https://kidsportcanada.ca/alberta/calgary/",
      "target": "_blank"
    }
  }, [_vm._v("Apply online")])]), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Triwood Dancers Society")]), _vm._v(" (our parent council) also provides grants to dancers in need to help cover registration costs. For more info, contact "), _c('a', {
    attrs: {
      "href": "mailto:triwooddancers@gmail.com",
      "target": "_blank"
    }
  }, [_vm._v("triwooddancers@gmail.com")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "right",
    attrs: {
      "id": "aurian"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": "/static/images/aurian.jpg",
      "alt": "Aurian Clarkson",
      "width": "200",
      "height": "200"
    }
  })]), _vm._v(" "), _c('div', [_c('header', [_c('h3', [_c('a', {
    attrs: {
      "href": "#aurian"
    }
  }, [_vm._v("Aurian Clarkson")])]), _vm._v(" "), _c('h4', [_vm._v("Teacher")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Aurian comes from a family of dancers and rejoined highland as an adult when her loungeroom hosted the beginning of the parent dance school to CSHD in Perth. She loves dance, movement, and the community that is built around practise and performance. Aurian genuinely enjoys instilling the love of dance in our community of dancers and helping them to use their classes and practise to build life skills and resilience. She is a member of the BATD, an engineer, a management consultant by day, and a mother to 3 fantastic dancers.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    staticClass: "right",
    attrs: {
      "id": "alexandra"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": "/static/images/alexandra.jpg",
      "alt": "Alexandra Campbell",
      "width": "200",
      "height": "274"
    }
  })]), _vm._v(" "), _c('div', [_c('header', [_c('h3', [_c('a', {
    attrs: {
      "href": "#alexandra"
    }
  }, [_vm._v("Alexandra Campbell")])]), _vm._v(" "), _c('h4', [_vm._v("Director")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Alexandra has been dancing and teaching for more than 30 years, competing and performing with enthusiasm for the large majority. She's a member of SDTA and ScotDance Canada and performed in the Spasskaya Tower International Military Tattoo in Moscow, Russia. In her spare time, Alexandra is a geophysicist, a mom of two, and creates handmade choreography outfits for the studio. Alexandra’s natural competitiveness, coupled with a high energy teaching style, brings out the athleticism, technical precision, and joy of excellence in her dancers. Alexandra also deeply values the community that dance provides, and loves watching dancers discover their full potential because of the friendships that form in classes.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('article', {
    attrs: {
      "id": "elayna"
    }
  }, [_c('figure', [_c('img', {
    attrs: {
      "src": "/static/images/elayna.jpg",
      "alt": "Elayna Campbell",
      "width": "200",
      "height": "274"
    }
  })]), _vm._v(" "), _c('div', [_c('header', [_c('h3', [_c('a', {
    attrs: {
      "href": "#elayna"
    }
  }, [_vm._v("Elayna Campbell")])]), _vm._v(" "), _c('h4', [_vm._v("Director")])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("Elayna's dance career began at age nine, and quickly became her main focus. She has now been competing, performing, and teaching for over 25 years, including dancing in the world-famous Basel and Edinburgh International Tattoos. She is currently a member of both SDTA and ScotDance Canada. Complementing her love of dance, Elayna is also a passionate elementary teacher with the Calgary Board of Education. Elayna uses her natural positivity and compassionate nature, balanced with high expectations, to help each dancer achieve their goals.")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_c('a', {
    attrs: {
      "href": "#contact"
    }
  }, [_vm._v("Contact")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "table"
  }, [_c('tbody', [_c('tr', [_c('td', [_vm._v("Your name")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "text",
      "name": "name",
      "required": ""
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Your email")]), _vm._v(" "), _c('td', [_c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "required": ""
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Your message")]), _vm._v(" "), _c('td', [_c('textarea', {
    attrs: {
      "name": "message",
      "required": ""
    }
  })])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v(" ")]), _vm._v(" "), _c('td', [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Send")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('h2', [_c('a', {
    attrs: {
      "href": "#photos"
    }
  }, [_vm._v("Photos")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "bg-tartan align-center",
    attrs: {
      "id": "guides"
    }
  }, [_c('header', [_c('h2', [_c('a', {
    attrs: {
      "href": "#guides"
    }
  }, [_vm._v("Guides")])])]), _vm._v(" "), _c('div', [_c('p', [_vm._v("We've collected together some handy information to help dancers and parents navigate the world of Highland dancing—take a look if you are curious (or can't remember)!")]), _vm._v(" "), _c('p', [_c('a', {
    staticClass: "btn",
    attrs: {
      "href": "https://drive.google.com/open?id=1Ep1Jb9GeEBkH8OiXCu3v_DW_sel4RHbt",
      "target": "_blank"
    }
  }, [_vm._v("View Guides")])])])])
}]}

/***/ }),

/***/ 111:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpeg": 39,
	"./2.jpeg": 40,
	"./3.jpeg": 41,
	"./4.jpeg": 42,
	"./5.jpeg": 43,
	"./6.jpeg": 44,
	"./7.jpeg": 45,
	"./8.jpeg": 46
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 111;

/***/ }),

/***/ 112:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./1.jpeg": 39,
	"./2.jpeg": 40,
	"./3.jpeg": 41,
	"./4.jpeg": 42,
	"./5.jpeg": 43,
	"./6.jpeg": 44,
	"./7.jpeg": 45,
	"./8.jpeg": 46
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;

/***/ }),

/***/ 25:
/***/ (function(module, exports) {

module.exports = {
  AU: {
    name: 'Australia',
    flag: '🇦🇺',
    nationality: 'Australian',
    url: 'https://oz.campbelldancers.com',
    email: 'hello.oz@campbelldancers.com',
    emailSignature: 'Aurian',
    phone: '0401 054 321',
    phoneContact: 'me',
    startMonth: 'March',
    instagram: 'campbelldancersoz',
    links: [
      {
        name: 'CSHDAustralia on Facebook',
        url: 'https://www.facebook.com/campbelldancersOZ/',
      },
      {
        name: 'CSHDAustralia on Instagram',
        url: 'https://www.instagram.com/campbelldancersoz/',
      },
      {
        name: 'WAMRCHDI',
        url: 'https://wamrchdi.webs.com/',
      },
      {
        name: 'ABHDI',
        url: 'https://www.abhdi.com/',
      },
    ],
  },
  CA: {
    name: 'Canada',
    flag: '🇨🇦',
    nationality: 'Canadian',
    url: 'https://campbelldancers.com',
    email: 'hello@campbelldancers.com',
    emailSignature: 'Alexandra and Elayna',
    phone: '403-998-0111',
    phoneContact: 'Elayna',
    startMonth: 'September',
    instagram: 'campbelldancers',
    links: [
      {
        name: 'CSHD on Facebook',
        url: 'https://www.facebook.com/campbelldancers/',
      },
      {
        name: 'CSHD on Instagram',
        url: 'https://www.instagram.com/campbelldancers/',
      },
      {
        name: 'Calgary Highland Dancing Association',
        url: 'http://www.chda.ab.ca/',
      },
      {
        name: 'Alberta Highland Dancing Association',
        url: 'http://www.ahda.ab.ca/',
      },
    ],
  },
};


/***/ }),

/***/ 39:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/1.8438f90.jpeg";

/***/ }),

/***/ 40:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/2.fecfa6f.jpeg";

/***/ }),

/***/ 41:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/3.cd65747.jpeg";

/***/ }),

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/4.89fb0f9.jpeg";

/***/ }),

/***/ 43:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/5.3c7df25.jpeg";

/***/ }),

/***/ 44:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/6.40900c2.jpeg";

/***/ }),

/***/ 45:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/7.330c460.jpeg";

/***/ }),

/***/ 46:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/8.66b0aa4.jpeg";

/***/ }),

/***/ 47:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(52),
  /* template */
  __webpack_require__(104),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 48:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_Home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Privacy__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Privacy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_Privacy__);





__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  mode: 'history',
  routes: [{
    path: '/',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Home___default.a
  }, {
    path: '/privacy',
    name: 'privacy',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Privacy___default.a
  }],
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    if (savedPosition) return savedPosition;
    if (to.hash) {
      return {
        selector: to.hash
      };
    }
    return {
      x: 0,
      y: 0
    };
  }
}));

/***/ }),

/***/ 49:
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(95)

var Component = __webpack_require__(14)(
  /* script */
  __webpack_require__(51),
  /* template */
  __webpack_require__(106),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 50:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "country", function() { return country; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "countryFilter", function() { return countryFilter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(48);




__WEBPACK_IMPORTED_MODULE_0_vue___default.a.config.productionTip = false;
var country = window.location.search.indexOf('oz') >= 0 || window.location.hostname.indexOf('oz') >= 0 ? 'AU' : 'CA';
var countryFilter = function countryFilter(item) {
  if (item.country) {
    return item.country === country;
  }
  if (item['@countries']) {
    return !!item['@countries'][country];
  }
  return country === 'CA';
};
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.prototype.country = country;

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_1__App___default.a);
  }
});

/***/ }),

/***/ 51:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_helpers_countries__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__functions_helpers_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__functions_helpers_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EnrollButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EnrollButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_EnrollButton__);





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app',
  data: function data() {
    return {
      menuToggled: false,
      year: new Date().getFullYear(),
      countries: __WEBPACK_IMPORTED_MODULE_0__functions_helpers_countries___default.a
    };
  },

  methods: {
    handleCountryChange: function handleCountryChange() {
      var url = __WEBPACK_IMPORTED_MODULE_0__functions_helpers_countries___default.a[this.country].url;

      window.location.href = '' + url + this.$route.fullPath;
    }
  },
  components: {
    EnrollButton: __WEBPACK_IMPORTED_MODULE_1__components_EnrollButton___default.a
  }
});

/***/ }),

/***/ 52:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'EnrollButton'
});

/***/ }),

/***/ 53:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vueperslides__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vueperslides___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vueperslides__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueperslides_dist_vueperslides_css__ = __webpack_require__(93);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueperslides_dist_vueperslides_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vueperslides_dist_vueperslides_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_helpers_countries__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__functions_helpers_countries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__functions_helpers_countries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnrollButton__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EnrollButton___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EnrollButton__);









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      menuToggled: false,
      scrollTop: 0,
      countries: __WEBPACK_IMPORTED_MODULE_4__functions_helpers_countries___default.a,

      images: __webpack_require__(111).keys().map(function (key) {
        return __webpack_require__(112)("./" + key.replace('./', ''));
      })
    };
  },

  computed: {
    bannerOffset: function bannerOffset() {
      var height = this.$refs.banner ? this.$refs.banner.offsetHeight : 0;
      return this.scrollTop && height ? 1 - (height - this.scrollTop) / height : 0;
    },
    info: function info() {
      return this.countries[this.country];
    },
    otherCountry: function otherCountry() {
      if (this.country === 'CA') {
        return 'AU';
      }
      return 'CA';
    },
    otherInfo: function otherInfo() {
      return this.countries[this.otherCountry];
    },
    locations: function locations() {
      var _this = this;

      return [{
        country: 'CA',
        name: '19 Street Studio',
        address: '3803 19 St NW\nCalgary, AB T2L 2B3'
      }, {
        country: 'CA',
        name: 'Triwood Community Center',
        address: '2244 Chicoutimi Dr NW\nCalgary, AB T2L 0W1'
      }, {
        country: 'AU',
        name: 'Attadale',
        address: 'Western Australia'
      }].filter(function (location) {
        return location.country === _this.country;
      });
    }
  },
  methods: {
    encodeURIComponent: window.encodeURIComponent,

    handleScroll: function handleScroll(e) {
      if (e.target.scrollingElement) {
        this.scrollTop = e.target.scrollingElement.scrollTop;
      }
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              window.addEventListener('scroll', _this2.handleScroll);

            case 1:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  components: {
    EnrollButton: __WEBPACK_IMPORTED_MODULE_5__EnrollButton___default.a,
    VueperSlides: __WEBPACK_IMPORTED_MODULE_2_vueperslides__["VueperSlides"],
    VueperSlide: __WEBPACK_IMPORTED_MODULE_2_vueperslides__["VueperSlide"]
  }
});

/***/ }),

/***/ 54:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'privacy'
});

/***/ }),

/***/ 93:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 94:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 95:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 96:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[50]);


// WEBPACK FOOTER //
// static/js/app.1dd5b59654d0ff669a3d.js